import { useContext } from "react";
import { GlobalStateContext } from "../GlobalState";

const useGlobalState = () => {
  const globalState = useContext(GlobalStateContext);
  return globalState;
};

export default useGlobalState;
